import styled from 'styled-components';
import DropdownArrow from '../../../assests/images/linear-arrow-down.svg';
import RightIcon from '../../../assests/images/white-right-icon.svg';

export const EditProfileSection = styled.div`
.remove-button{
    background: #01606F;
    box-shadow: 0px 5px 20px #0000001A;
    border-radius: 7px;
    border:none;
    color: #FFFFFF;
    font-size: 16px;
    line-height: normal;
    cursor: pointer;
    outline:none;
    margin: 2px -12px;
    padding: 12px 14px;
}
`;

export const Title = styled.h1`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size:40px;
    font-weight: bold;
    line-height: 58px;
    margin-bottom: 30px;     
   @media screen and (max-width:1199px) {
      font-size: 35px;
      line-height: 40px;
  }
  @media screen and (max-width:991px) {
      font-size: 30px;
      line-height: 35px;
  }
  @media screen and (max-width:575px) {
      font-size: 28px;
      line-height: 40px;
      margin-bottom: 20px;
  }
  
`;

export const SubTitle = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom:20px;
  button{
       background: transparent;
        border: none;
        color: #33A7AE;
        width: 100%;
        text-align: right;
        font-weight: 500;
      &:hover{
       background: transparent;
        color: #33A7AE;
       }  
   }
`;
export const SubTitleNumber = styled.span`
    background: #33A7AE  ;
    border-radius: 15px;
    color: #fff;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: bold;
    line-height: 60px;
    margin-bottom: 0px;
    width:60px;
    min-width:60px;
    height:60px;
    display: flex;
    justify-content: center;

  @media screen and (max-width:575px) {
      font-size: 20px;
      line-height: 50px;
      width:50px;
      min-width:50px;
      height:50px;
  }

  
`;


export const SubTitleText = styled.h2`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:30px;
    font-weight: 600;
    line-height: 43px;
    margin-bottom: 0px;
 
  @media screen and (max-width:575px) {
      font-size: 25px;
      line-height: 40px;
  }
  
`;
export const OrganizationSection = styled.div`
   
`;


export const OrganizationForm = styled.form`
    background: #FFFFFF  ;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding:20px;
    .form-label {
        color: #000;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 23px;
        margin-bottom: 5px;
    }
    .form-control {
        background: #0000000D  ;
        border-radius: 10px;
        height: 50px;
        padding: 10px 15px 13px 15px;
        color: rgb(0 0 0 / 50%);
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: normal;
        line-height: 23px;
       @media screen and (max-width:575px) {
            font-size: 13px;
      }
    }
    .form-select {
        background-color: #0000000D;
        color: rgb(0 0 0 / 50%);
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: normal;
        line-height: 23px;
        background-image:url(${DropdownArrow});
        background-size: 24px;
        height: 50px;
       &:focus {
            border-color: none;
            box-shadow: none;
            border: 1px solid  #86b7fe;
        } 
     }
    .input-box {
        margin-bottom: 20px;
        @media screen and (max-width:575px) {
            margin-bottom: 10px;
            margin-top: 10px;
        }

        &.website-link-box{
            margin-top: 20px;
            margin-bottom: 30px;
        }
    }

    .form-check-input:focus {
        box-shadow:none;
    }
            button.tooltipBtn.btn.btn-primary {
        position: relative;
        top: -7px;
   }
    .multiSelectContainer {
        margin-top: -6px;
    
        input{
            padding: 5px 15px 5px 15px; 
            margin-top: 0;
        }
        ul {
            border: none;
            li:hover {
                background:#33A7AE;
            }
        }
    }
     .highlightOption{
        background:#33A7AE;
    }
    .searchWrapper{
       position:relative;
           border: 1px solid #0000000D;
        border-radius: 10px; 
         background-color: #0000000D;
       &:after{
        border: none;
        background-image:url(${DropdownArrow});
       background-repeat: no-repeat;
        background-position: 99% 46%;
        cursor: pointer;
        content:"";
        border-radius: 10px;
        background-repeat: no-repeat;
        background-position: 99% 46%;
        cursor: pointer;
        content: "";
        width: 24px;
        height: 24px;
        position: absolute;
        right: 5px;
        top: 11px;
        }
    }
    .chip {
        background: #D4D4D4  ;
        border-radius: 10px !important;
        color: rgb(0 0 0 / 50%);
        font-size: 14px;
        line-height: 20px;
        padding: 6px 14px 6px 32px;
        position: relative;
        width:95%;
        
    }

    .custom-close {
        position: absolute;
        left: 0;
        top: 9px;
        width: 28px;
        height: 21px;
        opacity: 0.5;
    }
    
    
      .custom-close:hover {
        opacity: 1;
      }
      .custom-close:before, .custom-close:after {
        position: absolute;
        left: 15px;
        content: ' ';
        height: 15px;
        width: 2px;
        background-color: #333;
      }
      .custom-close:before {
        transform: rotate(45deg);
      }
      .custom-close:after {
        transform: rotate(-45deg);
      }
      .tooltipBtn{
        background: transparent;
        border: none;
       &:active{
        background: transparent;
       } 
    }
    .optionListContainer{
        background: #FFFFFF;
        box-shadow: 0px 10px 30px #00000033;
        border-radius: 10px;
        padding: 15px 20px;
    }
   
`;
export const FromButton = styled.div`
    display: flex;
    justify-content: start;
    gap: 15px;

    .btn-outline-success-blue{
        padding: 12px 30px;
        margin-top: 10px;
    }
    .btn-outline{
        background: #fff;
        color: #01606F;
        font-family: "Jost", sans-serif;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        padding: 10px 51px;
        transition: all 0.5s;
        border-radius: 10px;
        box-shadow: 0px 5px 20px #0000001A;
        border: 1px solid #01606F;
        border-radius: 10px;

        &:hover{
            background: #FFD495 !important;
            color: #333333 !important;
            transition: all 0.5s;
            border: 1px solid #FFD495;
        } 
    }
`;

export const MediaSection = styled.div`
  margin-top:40px;
  .input-group-text {
    background: #01606F;
    box-shadow: 0px 5px 20px #0000001A;
    border-radius: 7px;
    border:none;
    color: #FFFFFF;
    font-size: 16px;
    line-height: normal;
    max-width: 110px;
    justify-content: center;
    align-items: center;
    padding: 7px 12px 10px 12px;
    display: inline-flex;
    width: 100%;
    position: absolute;
    right: 5px;
    top: 5px;
    cursor: pointer;
    outline:none;
}
.profile-upload {
    position: relative;
    width: 100%;
    height: 50px;
    background: #0000000D;
    border: 1px solid #0000000D;
    border-radius: 10px;
    display: flex;
    align-items: center;
}
    
.upload-logo-img {
    padding-left: 55px;
    padding-right: 115px;
}
.upload-input{
    display:none;
}
.text-media{
    color: rgb(0 0 0 / 60%);
    font-family: "Jost", sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 18px;
    display: block;
    margin-top: 10px;
    margin-bottom: 20px;
}
.upload-box{
 @media screen and (max-width:991px){
     margin-bottom: 15px;
 }
    .form-label{
        margin-bottom: 10px;
    }
}

.youtube-input {
    padding-left: 55px !important;
        padding-right: 121px;
}
 ${FromButton}{
    margin-top: 30px;
 }


`;


export const PopoverSection = styled.div`
background: #FFFFFF  ;
box-shadow: 0px 0px 20px #00000029;
border: 2px solid #FFFFFF33;
border-radius: 15px;
z-index:99;
width:100%;
max-width:380px;
.popover-body{
    color: #000000;
    font-size: 14px;
    line-height: 18px;
    font-family: "Jost", sans-serif;
     width:380px;
     padding:20px !important;
}
.popover-basic{
    border:none !important;
}
.popover-arrow {
    display: none !important;
}
`;


export const TooltipBox = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
`;



export const FileUploadImage = styled.div`
        position: absolute;
        background: #01606F;
        border-radius: 7px;
        top: 5px;
        left: 5px;
        padding: 8px;
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
       
    img{
        width: 24px;
        height: 24px;
        min-width: 24px;

    }    
`;

export const InputBox = styled.div`

`;

export const SpanText = styled.span`
   color: #333333;
   font-family: "Jost", sans-serif;
   font-size:14px;
   font-weight: normal;
   line-height: 20px;
   margin-bottom: 0px;
`;

export const YourImpact = styled.div`
   margin-top:40px;
   ${FromButton}{
    margin-top: 30px;
 }
`;



export const CustomRadioBox = styled.div`
display: flex;
align-items: center;
margin-bottom:15px;
margin-top: 20px;
.form-check-label {
    color: #000;
    font-size: 16px;
    line-height: 27px;
    font-family: "Jost", sans-serif;
    font-weight: 500;
}
.form-check-input {
    width: 24px;
    height: 24px;
    margin-right: 10px;
}
.form-check-input {
    --bs-form-check-bg: rgb(0 0 0 / 50%);
    border: none;
    border-radius: 7px;
}
.form-check-input:checked[type=radio]{
    --bs-form-check-bg-image:url(${RightIcon});
    background-size: 12px;

}
.form-check-input:checked {
   background-color: #000;
    border: none;
}

`;


export const WebsiteAddress = styled.div`
    background: #0000000D  ;
    border: 1px solid #0000000D;
    border-radius: 10px;
    padding:20px;
    .input-box:last-child{
        margin-bottom:0;
    }
`;

export const ImpactText = styled.span`
  color: #333333;
  font-family: "Jost", sans-serif;
  font-size:20px;
  font-weight: 400;
  line-height: 30px;
`;

export const AdditionalInformationSection = styled.div`
   margin-top:40px;
   textarea.form-control{
    height:150px;
   }
   .social-box{
    position: relative;
   .form-control{
        padding-left: 56px;
    }
   }
`;

export const SocialIcon = styled.span`
    background: #4267B2  ;
    border-radius: 7px;
    width: 40px;
    display: inline-flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 5px;
    left:5px;
`;


export const TwitterImageIcon = styled.span`
    background: #000000;
    border-radius: 7px;
    width: 40px;
    display: inline-flex;
    height: 40px;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 5px;
    left:5px;
`;

export const SubTitlebtn = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
   gap: 10px;
`;